(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bundle-selector')) {
    class BundleSelector extends HTMLElement {
      connectedCallback() {
        try {
          this.data = JSON.parse(this.querySelector('[data-bb-json]').textContent);
        } catch (e) {
          return;
        }
        this.section = this.closest('.shopify-section') || document;
        this.button = this.querySelector('[data-bb-add]');
        this.errorEl = this.querySelector('[data-bb-error]');

        this.onAnyChange = () => setTimeout(() => this.render(), 60);
        this.section.addEventListener('change', this.onAnyChange);
        this.addEventListener('click', (e) => { if (e.target.closest('.bb__option')) setTimeout(() => this.render(), 0); });
        document.addEventListener('variant:update', this.onAnyChange);
        this.button.addEventListener('click', () => this.add());

        this.watchPrice();
        this.render();
      }

      disconnectedCallback() {
        this.section?.removeEventListener('change', this.onAnyChange);
        document.removeEventListener('variant:update', this.onAnyChange);
        this.observer?.disconnect();
        this.priceObserver?.disconnect();
      }

      get variant() {
        const variants = this.data.variants;
        const picker = this.section.querySelector('variant-picker');
        if (picker) {
          const values = [...picker.querySelectorAll('fieldset input:checked, select')].map((el) => el.value);
          if (values.length) {
            const match = variants.find((v) => values.every((val) => v.options.includes(val)));
            if (match) return match;
          }
        }
        const idInput = this.section.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
        return (
          variants.find((v) => String(v.id) === String(idInput?.value)) ||
          variants.find((v) => v.available) ||
          variants[0]
        );
      }

      money(cents) {
        const fmt = (this.data.moneyFormat || '£{{amount}}').replace(/<[^>]*>/g, '');
        const n = cents / 100;
        const delim = (num, dec, th = ',', dp = '.') => {
          const [i, f] = num.toFixed(dec).split('.');
          return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (f ? dp + f : '');
        };
        return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
          if (key === 'amount_no_decimals') return delim(n, 0);
          if (key === 'amount_with_comma_separator') return delim(n, 2, '.', ',');
          if (key === 'amount_no_decimals_with_comma_separator') return delim(n, 0, '.', ',');
          return delim(n, 2);
        });
      }

      totals(price, qty, discount) {
        const full = price * qty;
        const unit = Math.round((price * (100 - discount)) / 100);
        const total = unit * qty;
        return { full, total, each: unit, save: full - total };
      }

      render() {
        const v = this.variant;
        this.current = v;
        const options = [...this.querySelectorAll('.bb__option')];

        options.forEach((opt) => {
          const qty = Number(opt.dataset.qty);
          const disc = Number(opt.dataset.discount);
          const t = this.totals(v.price, qty, disc);
          const notEnough = v.available && v.managed && v.policy === 'deny' && v.inventory < qty;
          const ok = v.available && !notEnough;

          opt.classList.toggle('is-disabled', !ok);
          opt.querySelector('.bb__radio').disabled = !ok;
          opt.querySelector('[data-bb-price]').textContent = this.money(t.total);

          const cmp = opt.querySelector('[data-bb-compare]');
          if (cmp) cmp.textContent = this.money(t.full);

          const each = opt.querySelector('[data-bb-each]');
          if (each) each.textContent = `${this.money(t.each)} each`;

          const saving = opt.querySelector('[data-bb-saving]');
          if (saving) saving.textContent = `You save ${this.money(t.save)}`;

          const stock = opt.querySelector('[data-bb-stock]');
          if (stock) {
            stock.hidden = !notEnough;
            stock.textContent = notEnough ? `Only ${Math.max(v.inventory, 0)} left in this size` : '';
          }
        });

        let selected = this.querySelector('.bb__radio:checked');
        if (!selected || selected.disabled) {
          const firstOk = this.querySelector('.bb__radio:not(:disabled)');
          if (firstOk) firstOk.checked = true;
          selected = firstOk;
        }
        options.forEach((opt) => opt.classList.toggle('is-selected', !!selected && opt.contains(selected)));

        const tag = this.querySelector('[data-bb-tag]');
        if (tag) {
          const badge = selected ? selected.closest('.bb__option').dataset.badge : '';
          tag.textContent = badge || '';
          tag.hidden = !badge;
        }

        const btnText = this.querySelector('[data-bb-btn-text]');

        if (!selected) {
          this.button.disabled = true;
          btnText.textContent = 'Sold out';
          return;
        }

        const opt = selected.closest('.bb__option');
        const t = this.totals(v.price, Number(opt.dataset.qty), Number(opt.dataset.discount));
        this.button.disabled = false;
        btnText.textContent = `${this.data.label} — ${this.money(t.total)}`;
        this.updatePrice();
      }

      priceEl() {
        return this.section.querySelector('product-price [ref="priceContainer"]');
      }

      watchPrice() {
        const host = this.section.querySelector('product-price');
        if (!host) return;
        this.priceObserver?.disconnect();
        this.priceObserver = new MutationObserver(() => {
          if (this.writingPrice) return;
          const el = this.priceEl();
          if (el && el.dataset.bbApplied !== 'true') this.updatePrice();
        });
        this.priceObserver.observe(host, { childList: true, subtree: true });
      }

      updatePrice() {
        const el = this.priceEl();
        const selected = this.querySelector('.bb__radio:checked');
        const opt = selected?.closest('.bb__option');
        if (!el || !opt || !this.current) return;

        if (el.dataset.bbApplied !== 'true') this.originalPrice = el.innerHTML;

        const qty = Number(opt.dataset.qty);
        const disc = Number(opt.dataset.discount);

        this.writingPrice = true;
        if (qty === 1 && disc === 0) {
          if (this.originalPrice != null && el.dataset.bbApplied === 'true') el.innerHTML = this.originalPrice;
          delete el.dataset.bbApplied;
        } else {
          const t = this.totals(this.current.price, qty, disc);
          const compare = disc > 0
            ? `<span class="price-item__group"><span class="price-item--regular compare-at-price">${this.money(t.full)}</span></span>`
            : '';
          el.innerHTML = `<div class="price__sale"><span class="price-item__group"><span class="price-item--sale price">${this.money(t.total)}</span></span>${compare}</div>`;
          el.dataset.bbApplied = 'true';
        }
        Promise.resolve().then(() => { this.writingPrice = false; });
      }

      watchThemeError() {
        this.observer?.disconnect();
        const err = this.section.querySelector('.product-form-text__error');
        if (!err) return;
        this.observer = new MutationObserver(() => {
          const text = err.textContent.trim();
          if (!err.classList.contains('hidden') && text) {
            this.errorEl.textContent = text;
            this.errorEl.hidden = false;
          }
        });
        this.observer.observe(err, { attributes: true, childList: true, subtree: true, characterData: true });
      }

      async add() {
        const selected = this.querySelector('.bb__radio:checked');
        if (!selected || !this.current) return;
        const qty = Number(selected.closest('.bb__option').dataset.qty);
        this.errorEl.hidden = true;

        const form = this.section.querySelector('form[data-type="add-to-cart-form"]');
        const qtyInput = form?.querySelector('input[name="quantity"]');
        const idInput = form?.querySelector('input[name="id"]');
        if (form && qtyInput && idInput) {
          this.watchThemeError();
          idInput.value = this.current.id;
          qtyInput.max = '';
          qtyInput.value = qty;
          form.requestSubmit();
          return;
        }

        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        this.button.disabled = true;
        try {
          const res = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: this.current.id, quantity: qty }] }),
          });
          if (!res.ok) {
            const j = await res.json().catch(() => ({}));
            throw new Error(j.description || j.message || 'Sorry, this could not be added to your cart.');
          }
          window.location.href = `${root}cart`;
        } catch (e) {
          this.errorEl.textContent = e.message;
          this.errorEl.hidden = false;
          this.button.disabled = false;
        }
      }
    }

    customElements.define('bundle-selector', BundleSelector);
  }
  } catch(e) { console.error(e); }
})();

})();
